import React from "react";
import { C, card } from "../lib/theme";

/* Mission page — intentionally sparse for now; the owner will write this. */
export default function Mission({ me }) {
  const inner = (
    <>
      <h1 style={{ fontFamily: C.displayFont, fontSize: 28, fontWeight: 500,
        margin: "0 0 12px" }}>Mission</h1>
      <div style={{ ...card, fontSize: 13.5, color: C.dim, lineHeight: 1.7 }}>
        This page is being written.
      </div>
    </>
  );
  if (me) return <div style={{ maxWidth: 720 }}>{inner}</div>;
  return (
    <div style={{ minHeight: "100vh", background: C.bg, color: C.text,
      fontFamily: C.font, padding: "30px 16px 60px" }}>
      <div style={{ maxWidth: 720, margin: "0 auto" }}>
        <div style={{ fontFamily: C.displayFont, fontSize: 22, marginBottom: 14 }}>
          Astrology Calendar</div>
        {inner}
      </div>
    </div>
  );
}
